import React from "react";
import data from "../../json/Allservices/Technology.json";
import { ReactComponent as Icon1 } from "../../../src/Icons/Tech1.svg";
import { ReactComponent as Icon2 } from "../../../src/Icons/Tech2.svg";
import { ReactComponent as Icon3 } from "../../../src/Icons/Tech3.svg";
import { ReactComponent as Icon4 } from "../../../src/Icons/Tech4.svg";

const Section2 = () => {
  const icons = [Icon1, Icon3, Icon2, Icon4];
  return (
    <div className="w-full flex justify-center relative tech-after pb-20 md:pb-[200px]">
      <div className="2xl:container w-full px-6 pt-10 md:px-10 lg:px-20 flex flex-col ">
        <section className="w-full flex flex-col items-center ">
          <div className="flex flex-col gap-4 lg:text-left text-center items-center w-full lg:w-[70%]">
            <h1 className="text-28 sm:text-36 lg:text-48 text-center font-semibold text-primarycolor w-full">{data.section1.title}</h1>
            <p className="text-14 sm:text-16 md:text-18 text-center text-secondaryblack ">
              {data.section1.desc2}
            </p>
          </div>
        </section>
        <section className="w-full  flex mt-10 sm:mt-20 ">
          <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6 lg:ml-5 relative">
            {data.section1.list.map((ele, i) => {
              let Icon = icons[i];
              return (
                <div className=" p-6 w-full  h-full rounded-[24px] border-[1px] border-[services] group serviceparent  shadow-services">
                  <div className="flex items-center flex-col gap-4 ">
                    <Icon className="serviceicon servicechild" />
                    <div className="text-center space-y-3 servicedetails">
                      <h1 className="text-18 md:text-20 font-semibold servicechild">
                        {ele.heading}
                      </h1>
                      <p className="text-14 md:text-16 text-approachblk servicechild pb-3">
                        {ele.desc}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Section2;
